import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Accordion from 'srcReact/components/common2/Accordion'
import Spinner from 'srcReact/components/common2/Spinner'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { settingsActions as sa } from '../../action'
import NotificationHeading from '../NotificationHeading'
import OptionsToggle from '../OptionsToggle'
import AccordionHeading from '../AccordionHeading'
import LinkBlock from '../LinkBlock'
import styles from './styles.module.scss'
import parentStyles from '../../styles.module.scss'

export default function NotificationsForm() {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { isNative } = useSelector((state) => state.common)
  const { current_organization } = useSelector((state) => state.organization)
  const {
    groupList,
    defaultNotificationList,
    reloadDefaultNotifications,
    notificationSettingUpdated,
    toggleAllSetting,
    loading
  } = useSelector((state) => state.settings)

  useEffect(() => {
    // nativeapp
    if (isNative) {
      const defaultPayload = {
        id_organization: urlSearchParams('organization_id'),
        type: 'default'
      }
      const groupPayload = {
        organization_id: urlSearchParams('organization_id'),
        scope: 'all'
      }
      dispatch(sa.getDefaultNotificationSettings(defaultPayload))
      dispatch(sa.getGroupList(groupPayload))
      return
    }

    const defaultPayload = {
      id_organization: current_organization && current_organization.info && current_organization.info.id,
      type: 'default'
    }
    const groupPayload = {
      organization_id: current_organization && current_organization.info && current_organization.info.id,
      scope: 'all'
    }
    dispatch(sa.getDefaultNotificationSettings(defaultPayload))
    dispatch(sa.getGroupList(groupPayload))
  }, [notificationSettingUpdated, toggleAllSetting, reloadDefaultNotifications])

  const mainNotificationsData = () => {
    let mainNotifications = []
    Object.keys(defaultNotificationList).map((dnl, index) => {
      if (dnl !== 'mute') {
        let mainData = {
          title: <AccordionHeading title={defaultNotificationList[dnl].title} data={defaultNotificationList[dnl]} />,
          description: (
            <OptionsToggle options={defaultNotificationList[dnl]} key={index} handleOptions={handleMainToggle} />
          )
        }
        mainNotifications.push(mainData)
      }
    })

    return mainNotifications
  }

  const handleMainToggle = (payload) => {
    dispatch(sa.updateNotificationSettings('default', payload))
  }

  const handleToggle = (payload) => {
    dispatch(sa.toggleAllSettings(payload))
  }

  return (
    <div className={`${styles.mainWrapper}`}>
      <div className={`${styles.boxWrapper}`}>
        <header className={`${styles.header}`}>{t('notification_settings.main_form.heading')}</header>
        {loading ? (
          <Spinner customCss={styles.loader} />
        ) : (
          <div className={`${styles.bodyWrapper}`}>
            <div className={`${styles.headingWrapper}`}>
              <NotificationHeading
                heading={t('notification_settings.main_form.global_options_heading')}
                description={t('notification_settings.main_form.time_description')}
              />
              {Object.keys(defaultNotificationList).map((dnl, index) =>
                dnl === 'mute' ? (
                  <OptionsToggle
                    id_type={'default'}
                    toggle_type={'global'}
                    key={index}
                    options={defaultNotificationList[dnl]}
                    handleOptions={handleToggle}
                  />
                ) : (
                  ''
                )
              )}
            </div>
            <div className={`${styles.headingWrapper}`}>
              <NotificationHeading
                heading={t('notification_settings.main_form.main_notifications_heading')}
                description={t('notification_settings.main_form.main_notifications_description')}
              />
              <Accordion data={mainNotificationsData()} className={parentStyles.notificationAccordion} />
            </div>
            <div className={`${styles.headingWrapper}`}>
              <NotificationHeading
                heading={t('notification_settings.main_form.group_notifications_heading')}
                description={t('notification_settings.main_form.group_notifications_description')}
              />
              <div className={`${styles.linkBlockWrapper}`}>
                {groupList.list &&
                  groupList.list.length > 0 &&
                  groupList.list.map((gl, index) => (
                    <LinkBlock
                      key={index}
                      title={gl.group_name}
                      role={gl.group_role}
                      groupId={gl.group_id}
                      picture={gl.picture}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
